import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

import { Box } from '@factorialco/deprecated-design-system'
import { AtsGetJobPostingPromotionAccessDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useQuery } from 'modules/core/hooks/useQuery'

import { JobPostingLayout } from 'modules/ats/components/job_postings/JobPostingLayout'
import { useAtsContext } from 'modules/ats/lib/atsContext'
import { useJobDetailsContext } from 'modules/ats/pages/JobsPage/JobDetails'
import { useGetMarketplaceCompanyInstallations } from 'modules/marketplace/hooks/integrations/companyInstallations/useGetMarketplaceCompanyInstallations'
import { useGetMarketplaceIntegrations } from 'modules/marketplace/hooks/integrations/useGetMarketplaceIntegrations'
import integrationCodes from 'modules/marketplace/lib/integrationCodes'

import { AtsIntegrations, JobBoards } from './JobBoards'

const JobPostingPromotion = () => {
  const { job } = useJobDetailsContext()
  const { company, access } = useCurrentSession()
  const { infojobsEnabled } = useAtsContext()
  const { navigation } = useNavigation()
  const navigate = useNavigate()

  const { data: accessData } = useQuery(AtsGetJobPostingPromotionAccessDocument, {
    variables: { id: job.id, accessId: access.id },
  })

  const canManageJobPostings = accessData?.ats._policies.manageJobPostings.can ?? false
  const hiringRole = accessData?.ats.jobPosting?.currentHiringRole[0]?.hiringRole ?? 'editor'
  const isReviewerRole = hiringRole === 'reviewer' && !canManageJobPostings

  const shouldFetchIntegrations = infojobsEnabled && job.isPublished && !isReviewerRole

  useEffect(() => {
    if (isReviewerRole) {
      navigate(
        navigation.ats.jobs.jobsId.applications.fullPath({
          jobId: job.id,
        })
      )
    }
  }, [isReviewerRole, navigate, navigation, job.id])

  const { data: integrationsData } = useGetMarketplaceIntegrations(
    {
      datoIds: [integrationCodes.infojobs, integrationCodes.indeed],
    },
    !shouldFetchIntegrations
  )

  const { data: companyInstallationsData } = useGetMarketplaceCompanyInstallations(
    {
      companyIds: [company.id],
    },
    !shouldFetchIntegrations
  )

  const installedIntegrations = integrationsData.reduce((acc: AtsIntegrations, current) => {
    const integration = companyInstallationsData.find((i) => i.integrationId === current.id)
    if (!integration) return acc

    acc[current.name.toLowerCase()] = integration
    return acc
  }, {})

  if (isReviewerRole) return null

  return (
    <JobPostingLayout job={job}>
      <Box gap="s48" paddingX="s64">
        {infojobsEnabled && job.isPublished && (
          <JobBoards job={job} installedIntegrations={installedIntegrations} />
        )}
      </Box>
    </JobPostingLayout>
  )
}

export default JobPostingPromotion
